import { ArrowLeft, BookOpenCheck, Check, Code2, RotateCcw, ShieldCheck, Sparkles, Star } from "lucide-react";
import { codingGates, interviewChecklist, totalQuestCount, worlds } from "../data/curriculum";
import type { ProgressState } from "../types";

type BackpackScreenProps = {
  progress: ProgressState;
  onBack: () => void;
  onReset: () => void;
};

export function BackpackScreen({ progress, onBack, onReset }: BackpackScreenProps) {
  const questPercent = Math.round((progress.completedQuests.length / totalQuestCount) * 100);
  const gatePercent = Math.round((progress.completedGates.length / codingGates.length) * 100);
  const mastered = interviewChecklist.filter((_, index) => {
    const threshold = ((index + 1) / interviewChecklist.length) * totalQuestCount;
    return progress.completedQuests.length >= threshold;
  }).length;

  return (
    <main className="backpack-screen">
      <header className="backpack-titlebar">
        <button type="button" className="icon-button" onClick={onBack} aria-label="返回地图"><ArrowLeft /></button>
        <div><small>成长记录</small><h1>我的冒险背包</h1></div>
        <span><Star /> {progress.stars} 星星币</span>
      </header>

      <section className="backpack-summary">
        <article>
          <BookOpenCheck />
          <div><small>知识关卡</small><strong>{progress.completedQuests.length} / {totalQuestCount}</strong><p>{questPercent}% 的知识地图已点亮</p></div>
        </article>
        <article>
          <Code2 />
          <div><small>MHA 手写</small><strong>{progress.completedGates.length} / {codingGates.length}</strong><p>{gatePercent}% 的代码机器已组装</p></div>
        </article>
        <article>
          <ShieldCheck />
          <div><small>面试护盾</small><strong>{mastered} / {interviewChecklist.length}</strong><p>掌握一项就少怕一个追问</p></div>
        </article>
      </section>

      <section className="world-inventory">
        <div className="section-heading"><Sparkles /><div><small>六枚世界徽章</small><h2>知识不是一长串，而是一张能走的地图</h2></div></div>
        <div className="badge-row">
          {worlds.map((world) => {
            const done = world.quests.filter((quest) => progress.completedQuests.includes(quest.id)).length;
            return (
              <div key={world.id} className={done === world.quests.length ? "earned" : ""} style={{ "--world-color": world.color } as React.CSSProperties}>
                <span>{done === world.quests.length ? <Check /> : world.number}</span>
                <strong>{world.name}</strong>
                <small>{done}/{world.quests.length}</small>
              </div>
            );
          })}
        </div>
      </section>

      <section className="checklist-panel">
        <div className="section-heading"><ShieldCheck /><div><small>来自手册第 69 页</small><h2>面试前自检清单</h2></div></div>
        <div className="checklist-grid">
          {interviewChecklist.map((item, index) => {
            const ready = index < mastered;
            return <div key={item} className={ready ? "ready" : ""}><span>{ready ? <Check /> : index + 1}</span><p>{item}</p></div>;
          })}
        </div>
      </section>

      <button className="reset-progress" type="button" onClick={onReset}><RotateCcw /> 重新开始冒险</button>
    </main>
  );
}
